"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/servicesSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServicesSection3366sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "1.5s" | "2s" | "2.5s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/icons/services-icon-01.svg" | "/Templates/Doccure/img/icons/services-icon-02.svg" | "/Templates/Doccure/img/icons/services-icon-03.svg" | "/Templates/Doccure/img/icons/services-icon-04.svg" */
    src: string;
    /** Detected variants: "Sports Injury Recovery" | "Post-Surgery Rehabilitation" | "Pain Management Treatments" | "Mobility & Movement" */
    h30Text: ReactNode;
    /** Detected variants: "Get back in the game faster with evidence-based muscle sprains, ligament injuries, and athletic performance" | "Guided recovery following orthopedic procedures. We coordinate with your surgeon to ensure safe." | "Reduce chronic pain from arthritis, back problems, or overuse injuries with targeted, drug-free treatments." | "Improve flexibility, balance, and everyday movement quality. Perfect for seniors or anyone wanting to move better." */
    p0Text: ReactNode;
    /** Detected variants: "/Templates/Doccure/img/service/service-1.jpg" | "/Templates/Doccure/img/service/service-2.jpg" | "/Templates/Doccure/img/service/service-3.jpg" | "/Templates/Doccure/img/service/service-4.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "col-xxl-3 col-xl-3 col-lg-6 col-md-6" */
    className?: string;
    /** Detected variants: "services-item-eighteen wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "services-details" */
    div0ClassName2?: string;
    /** Detected variants: "services-icon" */
    div0ClassName3?: string;
    /** Detected variants: "services-icon" */
    alt?: string;
    /** Detected variants: "img-fluid icon" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "services-button" */
    a0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
    /** Detected variants: "services-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
    /** Detected variants: "service-img" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName2?: string;
    servicesTagItems?: ServicesSectionTagsItem[];
};

type ServicesSectionTagsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Protocols" | "Prevention" | "Management" | "Strengthening" | "Therapy" | "Non-invasive" | "Mobility" | "Fall Prevention" */
    aText: ReactNode;
    /** Detected variants: "tag" */
    className?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeEighteenServicesSectionGeneratedProps = {
    divDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSection3366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSection3366sItem) => Partial<ComponentProps<"h3">>);
    divDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSection3366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "WHAT WE TREAT" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "Services Tailored to" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    /** Default: "Your Recovery" */
    sectionDiv0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "title" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/title-img-2.jpg" */
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    sectionDiv1ClassName?: string;
    servicesSection3366s: ServicesSection3366sItem[];
    servicesSection3366sItemWrapper?: (item: ServicesSection3366sItem, content: ReactNode) => ReactNode;
    servicesSection3366sRenderer?: (defaultNode: ReactNode) => ReactNode;
    servicesSection3366sImageVisible?: boolean;
    servicesSection3366sImageRenderer?: (item: ServicesSection3366sItem, defaultNode: ReactNode) => ReactNode;
    servicesSection3366sH3Visible?: boolean;
    servicesSection3366sH3Renderer?: (item: ServicesSection3366sItem, defaultNode: ReactNode) => ReactNode;
    servicesSection3366sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServicesSection3366sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    servicesSection3366sH3Props?: Partial<ComponentProps<"h3">> | ((item: ServicesSection3366sItem) => Partial<ComponentProps<"h3">>);
    servicesSectionTagsItemWrapper?: (item: ServicesSectionTagsItem, content: ReactNode) => ReactNode;
    servicesSectionTagsRenderer?: (defaultNode: ReactNode) => ReactNode;
};

const HomeEighteenServicesSectionGenerated: FC<HomeEighteenServicesSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "WHAT WE TREAT",
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Services Tailored to",
    sectionDiv0Div0H20H2Text2 = "Your Recovery",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt = "title",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/title-img-2.jpg",
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div1H30H3Props,
    divDiv0ImageWithBasePath0ImageProps,
    sectionDiv1ClassName,
    servicesSection3366s,
    servicesSection3366sItemWrapper,
    servicesSection3366sRenderer,
    servicesSection3366sImageVisible,
    servicesSection3366sImageRenderer,
    servicesSection3366sH3Visible,
    servicesSection3366sH3Renderer,
    servicesSection3366sImageProps,
    servicesSection3366sH3Props,
    servicesSectionTagsItemWrapper,
    servicesSectionTagsRenderer,
}) => {
    return (
        <section className="section services-section-eighteen pb-0">
            <div className="container">
                <div className="section-header-eighteen wow fadeInDown" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    <div className="sub-title">{sectionDiv0Div0Div0DivText}</div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>
                            {sectionDiv0Div0H20H2Text}
                            <br />
                            <span className="title-img">
                                {renderNode(sectionDiv0Div0H20Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0H20Span0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div0H20Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0H20Span0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0H20Span0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </span>
                            {sectionDiv0Div0H20H2Text2}
                        </h2>
                    ))}
                </div>
            </div>
            <div className={sectionDiv1ClassName ?? "row g-0"}>
                {renderCollectionNode(
                    servicesSection3366s,
                    (item: ServicesSection3366sItem) => (
                        <div className={item.className ?? "col-xxl-3 col-xl-3 col-lg-6 col-md-6"} key={item.key}>
                            <div className={item.div0ClassName ?? "services-item-eighteen wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                {renderItemNode(servicesSection3366sImageVisible, servicesSection3366sImageRenderer, item, (
                                    <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "service-img"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid img-one"} {...(typeof servicesSection3366sImageProps === "function" ? servicesSection3366sImageProps(item) : (servicesSection3366sImageProps ?? {}))} {...(typeof divDiv0ImageWithBasePath0ImageProps === "function" ? divDiv0ImageWithBasePath0ImageProps(item) : (divDiv0ImageWithBasePath0ImageProps ?? {}))} />
                                ))}
                                <div className={item.div0ClassName2 ?? "services-details"}>
                                    <div className={item.div0ClassName3 ?? "services-icon"}>
                                        {renderItemNode(servicesSection3366sImageVisible, servicesSection3366sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "services-icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid icon"} {...(typeof servicesSection3366sImageProps === "function" ? servicesSection3366sImageProps(item) : (servicesSection3366sImageProps ?? {}))} {...(typeof divDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "services-content"}>
                                        {renderItemNode(servicesSection3366sH3Visible, servicesSection3366sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof servicesSection3366sH3Props === "function" ? servicesSection3366sH3Props(item) : (servicesSection3366sH3Props ?? {}))} {...(typeof divDiv0Div0Div1H30H3Props === "function" ? divDiv0Div0Div1H30H3Props(item) : (divDiv0Div0Div1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                        <div className="services-tag">
                                            {renderCollectionNode(
                                                item.servicesTagItems ?? [],
                                                (item: ServicesSectionTagsItem) => (
                                                    <a href={item.href ?? "#"} className={item.className ?? "tag"} key={item.key}>{item.aText}</a>
                                                ),
                                                servicesSectionTagsItemWrapper,
                                                servicesSectionTagsRenderer
                                            )}
                                        </div>
                                        <a href={item.href ?? "#"} className={item.a0ClassName ?? "services-button"}>
                                            <i className={item.i0ClassName ?? "isax isax-arrow-right-1"}></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ),
                    servicesSection3366sItemWrapper,
                    servicesSection3366sRenderer
                )}
            </div>
        </section>
    );
};

export default HomeEighteenServicesSectionGenerated;
